import SECTIONS_TYPES from '../../../../../Constants/SectionsTypes'
import MenuItem from '@mui/material/MenuItem'
import { Grid, Select } from '@mui/material'

const SectionTypeSelect = ({ setSectionType, isAdmin }) => {
  const sectionTypeSelected = (event) => {
    setSectionType(event.target.value)
  }

  return (
    <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4 }} className="transaction-item">
      <label htmlFor="status">Section</label>
      <br />
      <Select
        id="status"
        variant="outlined"
        defaultValue={SECTIONS_TYPES.HOME}
        className="actions-field"
        onChange={sectionTypeSelected}
      >
        <MenuItem value={SECTIONS_TYPES.HOME}>Home</MenuItem>
        <MenuItem value={SECTIONS_TYPES.GALLERY}>Gallery</MenuItem>
        <MenuItem value={SECTIONS_TYPES.DONATE}>Donate</MenuItem>
        <MenuItem value={SECTIONS_TYPES.RECRUITMENT}>Recruitment</MenuItem>
        <MenuItem value={SECTIONS_TYPES.CUSTOM_SECTION}>Custom section</MenuItem>
        {isAdmin && (
          <MenuItem value={SECTIONS_TYPES.MARKETING_CUSTOM_SECTION}>
            Marketing custom section
          </MenuItem>
        )}
        <MenuItem value={SECTIONS_TYPES.NEWS}>News</MenuItem>
      </Select>
    </Grid>
  )
}

export default SectionTypeSelect
